import "@babel/polyfill";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import VueResource from "vue-resource";
import DocTitle from "./components/DocTitle.vue";
import VuetifyConfirm from "./components/confirm/index";
import * as Sentry from "@sentry/vue";

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.use(VuetifyConfirm);
Vue.use(require('vue-shortkey'));

Vue.http.options.root = process.env.VUE_APP_API_PATH + "/customer/centre";
Vue.http.interceptors.push((request, next) => {
  request.headers.set("Accept", "application/json");
  if (app && app.$store)
    request.headers.set("Accept-Language", app.$store.state.config.lang);
  // avoid looping over on user info check
  next(res => {
    if (res.status === 401) {
      // ignore duplicate navigation errors.
      router.push({ name: "signin" }).catch(e => {});
    }
    if (process.env.NODE_ENV === 'development' && res.status === 500 && typeof res.body.startsWith !== 'undefined' && res.body.startsWith("Proxy")) {
      router.push({ name: "signin" }).catch(e => {});
      console.log("Proxy Error");
    }
  });
});
// Sentry logging interceptor
Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (!response.ok && ![401, 403].includes(response.status)) {
      const errorData = {
        status: response.status,
        statusText: response.statusText,
        url: response.url,
        body: response.body,
      };

      Sentry.withScope(scope => {
        scope.setTag('api_failure', 'true')
        scope.setContext('api_request', {
          method: request.method,
          url: request.url,
          params: request.params,
        })
        scope.setContext('api_response', errorData)

        const error = new Error(`API Error: ${response.status} ${response.statusText} ${request.url}`);
        Sentry.captureException(error)
      })
    }
    return response;
  })
});
Vue.config.errorHandler = (err, vm, info) => {
  // Check if it's a vue-resource error
  if (err.url && err.status) {
    Sentry.withScope(scope => {
      scope.setTag('vue_resource_error', 'true')
      scope.setContext('api_error', {
        url: err.url,
        status: err.status,
        method: err.method,
        body: err.body,
      })
      Sentry.captureException(err)
    })
  } else {
    // Regular Vue error
    Sentry.withScope(scope => {
      scope.setTag('vue_error', 'true')
      scope.setContext('component', {
        name: vm.$options.name,
        lifecycleHook: info,
      })
      Sentry.captureException(err)
    })
  }
};
router.onError(error => {
  Sentry.captureException(error, {
    tags: { route: router.currentRoute.path }
  })
  console.error('Router error:', error)
})

Vue.component("vue-title", DocTitle);

let environment = (!!process.env.VUE_APP_ENV_NAME) ? process.env.VUE_APP_ENV_NAME : process.env.NODE_ENV;

if (process.env.NODE_ENV != 'development') {
  Sentry.init({
    Vue,
    release: "steps-customer-center@" + process.env.VUE_APP_VERSION,
    environment,
    dsn: "https://b66e8ca72258918c1987d4c92879444c@o4507826055020544.ingest.de.sentry.io/4507839868502096",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/app\.transpress\.bg\//],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
} else {
  console.log("Sentry disabled on development environment");
}

var app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

router.beforeResolve((to, from, next) => {
  if (to.meta && to.meta.rule) {
    let acl = app.$store.state.user.access;
    if (acl && acl.length > 0)
    {
      for (let idx = 0; idx < acl.length; idx ++) {
        if (acl[idx].path === to.meta.rule && !acl[idx].mode) {
          console.log("No permission to access " + to.name);
          if (from && from.name)
            next(false);
          else
            next({name:"dashboard", path:"/", replace:true});
          return;
        }
      }
    }
  }
  next();
});
